"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { Button } from "@/src/components/shadcn/ui/button";
import { useErrorLogs } from "@/src/lib/data-fetchers/error-log-fetchers";
import { useRetryReferralExport } from "@/src/lib/data-fetchers/referral-export-fetchers";
import { ErrorType } from "@/src/models/error-log";
import type { Task } from "@/src/models/task";
export function ReferralExportResult(t0) {
  const $ = _c(15);
  const {
    task
  } = t0;
  const {
    errorLogs
  } = useErrorLogs(task.id);
  const retry = useRetryReferralExport(task);
  const router = useRouter();
  let t1;
  if ($[0] !== errorLogs) {
    t1 = errorLogs.filter(_temp).sort(_temp2);
    $[0] = errorLogs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const latestError = t1[0];
  const t2 = retry.error?.message ?? latestError?.errorMessage ?? "Export failed. Check spreadsheet access, column headers, and referral details.";
  let t3;
  if ($[2] !== t2) {
    t3 = <p className="whitespace-pre-wrap text-sm" role="alert">{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-sm text-muted-foreground">Fix the issue, then retry the export. Completed EHR steps will not run again.</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== retry || $[6] !== router) {
    t5 = () => retry.mutate(undefined, {
      onSettled: () => router.refresh()
    });
    $[5] = retry;
    $[6] = router;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = retry.isPending ? "Exporting\u2026" : "Retry export";
  let t7;
  if ($[8] !== retry.isPending || $[9] !== t5 || $[10] !== t6) {
    t7 = <Button disabled={retry.isPending} onClick={t5}>{t6}</Button>;
    $[8] = retry.isPending;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t7) {
    t8 = <div className="space-y-3">{t3}{t4}{t7}</div>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp2(a, b) {
  return b.createdAt.localeCompare(a.createdAt);
}
function _temp(error) {
  return error.normalizedName === ErrorType.REFERRAL_SHEET_EXPORT;
}